import InnerComponent from '@Components//Inventory/StockTransfer/StockTransferForm';
import orgContainer from '@Components/AppContainer';

const CreateStockTransfer = () => ((orgContainer(InnerComponent)));
export default CreateStockTransfer;
